<template lang="html">
  <div class="dialog" v-if="show">
    <div class="content">
      <div class="title">
        <h4>{{title}}</h4>
        <span @click="close()"></span>
      </div>
      <div class="add" v-if="type === 8 || type === 9 || type === 10">
        <input type="text" v-model="keyword" :placeholder="`请输入想要添加的${cate}`" />
        <div class="butn" @click="appendKeyword()">添加</div>
      </div>
      <div class="listLabel">
        <!-- <p class="label" v-for="(i, d) in list" :key="`l${d}`" v-if="type === 5 || type === 6 || type === 8 || type === 9">
          <span>{{i.title}}</span>
          <img src="@assets/img/common/del.svg" alt="del" @click="cancelSelect(i)">
        </p> -->
        <span :class="{item: true, active: i.selected}" v-for="(i, d) in list" :key="d" @click="toggleItem(i)">
          {{i.title}}
        </span>
      </div>
      <div class="btn">
        <button @click="confirm()">确定</button><button @click="close">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'clueSources',
  data() {
    return {
      show: false,
      type: 1,
      list: '',
      cate: '',
      keyword: '',
      title: '请挑选您需要的信源',
      config: [
        {
          title: '请挑选您需要的信源',
          type: 1,
          cate: '信源'
        },
        {
          title: '请挑选您需要的信源',
          type: 2,
          cate: '信源'
        },
        {
          title: '请挑选您需要的信源',
          type: 3,
          cate: '信源'
        },
        {
          title: '请挑选您需要的信源',
          type: 4,
          cate: '信源'
        },
        {
          title: '设置您想要关注的微博',
          type: 5,
          cate: '微博'
        },
        {
          title: '设置您想要关注的微信',
          type: 6,
          cate: '微信'
        },
        {
          title: '请挑选您需要的信源',
          type: 7,
          cate: '信源'
        },
        {
          title: '设置订阅关键词',
          type: 8,
          cate: '关键词'
        },
        {
          title: '设置订阅关键词',
          type: 9,
          cate: '关键词'
        },
        {
          title: '设置订阅关键词',
          type: 10,
          cate: '关键词'
        }
      ],
      handlePromise: null,
      handleResolve: null,
      idstring: null
    }
  },
  methods: {
    close() {
      // 关闭
      this.list = []
      this.show = false
    },
    cancel() {
      // 取消操作，关闭弹窗
      if (this.handleResolve) {
        this.handleResolve(false)
        this.handlePromise = null
      }

      this.close()
    },
    confirm() {
      // 确认操作
      const ids = this.list.filter(i => i.selected).map(j => j.id).join(',')

      // if (!ids) {
      //   this.$toast('请先进行操作再确认')
      //   return
      // }

      if (this.type == 8 || this.type == 9 || this.type == 10) {
        this.saveKeyword()
        return
      }

      const info = {
        source_info: ids,
        source_type: this.type,
        idstring: this.idstring
      }

      common.myFetch(apis.clueFiltersSourcesSet, info)
      .then((res) => {
        if (res) {
          this.close()
          this.$toast(res)

          this.handleResolve(true)
        }
      })
    },
    open (t, i) {
      this.type = t - 0
      this.idstring = i
      this.init().then(() => {
        this.show = true
      })

      this.handlePromise = new Promise((resolve) => {
        this.handleResolve = resolve
      })

      return this.handlePromise
    },
    init() {
      this.config.forEach(i => {
        if (this.type === i.type) {
          this.title = i.title
          this.cate = i.cate
        }
      })

      return this.getList()
    },
    toggleItem(i) {
      this.$set(i, 'selected', !i.selected)
    },
    cancelSelect(i) {
      this.$set(i, 'selected', false)
    },
    getList() {
      // 获取列表
      let url = apis.clueFilterSources
      const type = this.type
      const info ={
        source_type: this.type,
        idstring: this.idstring
      }

      if (type === 8 || type === 9 || type === 10) {
        url = apis.clueKeywords
      }

      return common.myFetch(url, info)
      .then((res) => {
        if (res) {
          this.list = res.list
        }
      })
    },
    appendKeyword() {
      const key = this.keyword
      if (!key) {
        this.$toast('关键字不可为空')
        return
      }

      if (this.list.filter(i => {return i.title === key}).length > 0) {
        this.$toast('请不要输入重复关键字')
        return
      }

      const keyword = {
        id: key,
        selected: true,
        title: key
      }

      this.list.push(keyword)
      this.keyword = ''
    },
    saveKeyword() {
      const source = this.type
      const info = {
        source_type: source,
        subscribe_info: this.list.filter(j => j.selected).map(i => {return i.title}).join(',')
      }

      common.myFetch(apis.clueSaveKeyword, info)
      .then((res) => {
        if (res) {
          this.$toast(res)
          this.getList()
          this.close()
        }
      })
    }
  },
  mounted() {
    // this.init()
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.dialog{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 11111;
    background: rgba(#000000, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    .content{
      width:880px;
      height:550px;
      background:@bg;
      box-shadow:4px 4px 10px 0 rgba(5,10,15,0.05);
      border-radius:4px;
      padding: 20px 30px;
      position: relative;
      display: flex;
      flex-direction: column;
      .title{
        width: 100%;
        display: flex;
        margin-bottom: 7px;
        h4{
          height: 33px;
          font-size:24px;
          color:@dark;
          flex: 1;
        }
        span{
          display: block;
          width: 21px;
          height: 21px;
          background: url('../assets/img/common/close.svg') no-repeat;
          background-size: 100%;
          cursor: pointer;
        }
      }
      .add {
        height: 40px;
        display: flex;
        margin: 16px 0 6px;
        border-radius: 4px;
        overflow: hidden;
        input {
          background-color: rgba(185, 195, 195, .2);
          padding: 10px 20px;
          font-size: 14px;
          flex: 1;
          &::placeholder {
            color: @dateColor;
          }
        }
        .butn {
          width: 120px;
          height: 40px;
          background-color: @green;
          color: #fff;
          font-size: 14px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          &:hover {
            .btnHover;
          }
          &:active {
            .btnActive;
          }
        }
      }
      .listLabel{
        // max-height: 390px;
        margin-top: 30px;
        overflow-y: auto;
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        align-content: flex-start;
        .item{
          display: block;
          height: 28px;
          width: auto;
          min-width:80px;
          // flex-basis: 80px;
          line-height: 28px;
          border:1px solid transparent;
          border-radius:100px;
          font-size:14px;
          color:@sub;
          text-align: center;
          // padding: 0px 12px;
          margin: 0 10px 30px 0px;
          box-sizing: border-box;
          cursor: pointer;
          padding: 0 6px;
          &.active{
            color: @green;
            border: 1px solid @green;
          }
        }
        .label {
          min-width: 80px;
          height: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: rgba(185, 195, 195, .2);
          border-radius: 4px;
          padding: 0 10px;
          font-size: 14px;
          color: @dark;
          margin: 0 20px 20px 0;
          img {
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
      .btn{
        width: 100%;
        // padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        // position: absolute;
        left: 0px;
        bottom: 0px;
        button{
          width:120px;
          line-height:40px;
          background:#b9c3c3;
          border-radius:100px;
          font-size:14px;
          color:#ffffff;
          border: none;
          margin: 0px 10px;
          &:first-child{
              background: @green;
          }
          &:hover {
            .btnHover;
          }
          &:active {
            .btnActive;
          }
        }
      }
  }
}
</style>
